import CoursesInState from './courses-in-state'
import CoursesInStateQuery, { COURSES_IN_STATE_QUERY } from './courses-in-state.query'

export { CoursesInStateQuery, COURSES_IN_STATE_QUERY }

export default CoursesInState
